<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM10.5039 7.13622L16.5039 11.1362C17.1265 11.4994 17.1631 12.3674 16.6137 12.79L10.5039 16.8638C9.83721 17.2527 9 16.7718 9 16V8C9 7.22821 9.83721 6.74734 10.5039 7.13622Z"
    fill="currentColor"
  />
</svg>
